// tslint:disable:only-arrow-functions
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { createSquarePanelFromRecommendationsBestPerformingArticles } from '../common/best-performing-articles/square-panel-best-performing-articles';

export const squarePanelFromRecommendationsBestPerformingArticles =
  mergeMultipleConfigs(
    createSquarePanelFromRecommendationsBestPerformingArticles().styleWrapper,
    [
      {
        id: 'recommendations-data',
        contentTypeId: 'dynamic-collections-renderer',
        data: {
          loadingStateWrapper: {
            property: {
              values: [
                {
                  provider: 'id:square-panel-products-data-container',
                  property: 'panelName',
                },
                {
                  values: [
                    {
                      provider: 'GlobalStoreProviderService',
                      property: {
                        path: 'accounts.activeAccount.brandOrganisations',
                      },
                      filter: function (
                        brandOrganisations: [] | null | undefined,
                      ): boolean {
                        const hasBrandOrganisations =
                          !!brandOrganisations && brandOrganisations.length > 0;
                        return hasBrandOrganisations;
                      }.toString(),
                    },

                    {
                      provider: 'GlobalStoreProviderService',
                      property: {
                        path: 'accounts.activeAccount.sites',
                      },
                    },
                    {
                      provider: 'GlobalStoreProviderService',
                      property: {
                        path: 'session.siteId',
                      },
                    },
                    {
                      provider: 'id:best-performing-articles-day-range-select',
                      property: 'selectionChanged',
                      startWith: {
                        value: {
                          value: '7',
                          displayValue: '7 days',
                        },
                      },
                      transform:
                        'function (option) {\n      return option.value;\n    }',
                    },
                    {
                      provider: 'id:square-panel-root',
                      property: 'orderType',
                    },
                    {
                      provider: 'id:square-panel-root',
                      property: 'filterMissingImages',
                    },
                  ],
                  transform: function ([
                    brandOrganisations,
                    sites,
                    siteId,
                    datePeriodDays,
                    orderType,
                    filterMissingImages,
                  ]: [
                    { brandOrganisationId: string; brandId: string }[],
                    { siteId: string; brandId: string }[],
                    string,
                    number,
                    number,
                    boolean,
                  ]) {
                    const brandId = sites.find(
                      (site) => site.siteId === siteId,
                    )?.brandId;
                    const brandOrg = brandOrganisations.find(
                      (brandOrganisation) =>
                        brandOrganisation.brandId === brandId,
                    )?.brandOrganisationId;

                    const payloadProperties = {
                      brandOrg,
                      datePeriodDays,
                      orderType,
                      filterMissingImages,
                    };

                    return payloadProperties;
                  }.toString(),
                },
              ],
            },
          },
        },
      },
    ],
  );
